import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { licensesActions } from '../licenses/licenses.actions';
import { sadmActions } from '../sadm/sadm.actions';
import { lifeCycleActions } from './life-cycle.actions';

@Injectable()
export class LifeCycleEffects {
  private readonly actions$ = inject(Actions);
  private readonly router = inject(Router);

  initialize$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(lifeCycleActions.initialize),
      switchMap(() => [licensesActions.loadLicenses(), sadmActions.getSadmClients()]),
    ),
  );

  redirect$: Observable<Action> = createEffect(
    () =>
      this.actions$.pipe(
        ofType(lifeCycleActions.redirect),
        tap(({ url }) => this.router.navigate([url], { queryParamsHandling: 'merge' })),
      ),
    { dispatch: false },
  );
}
